import React from "react";
import { Modal, Button, Input, List, Spin, message, notification, Divider, Icon } from "antd";
import firebase from "../../Firebase";

class EngineeringDeletionModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      counts: {
        ddp: 0,
        telas: 0,
        corte: 0,
        costura: 0,
        acabados: 0,
        almacen: 0,
      },
      loadingCounts: false,
      isDeleting: false,
      confirmationText: "",
      password: "",
    };
  }

  componentDidUpdate(prevProps) {
    const { visible, op } = this.props;
    if (visible && (visible !== prevProps.visible || op !== prevProps.op)) {
      if (op) {
        this.fetchCounts();
      }
    } else if (!visible && prevProps.visible) {
      this.resetState();
    }
  }

  resetState = () => {
    this.setState({
      counts: {
        ddp: 0,
        telas: 0,
        corte: 0,
        costura: 0,
        acabados: 0,
        almacen: 0,
      },
      confirmationText: "",
      password: "",
      isDeleting: false,
    });
  };

  fetchCounts = async () => {
    const { op } = this.props;
    this.setState({ loadingCounts: true });
    try {
      const newCounts = {
        ddp: 0,
        telas: 0,
        corte: 0,
        costura: 0,
        acabados: 0,
        almacen: 0,
      };

      const collections = ["ddp", "telas", "corte", "costura", "acabados", "almacen"];
      for (const coll of collections) {
        const snap = await firebase
          .firestore()
          .collection(coll)
          .where("op", "==", op)
          .get();
        newCounts[coll] = snap.size;
      }
      this.setState({ counts: newCounts });
    } catch (error) {
      console.error("Error fetching counts:", error);
      message.error("Error al calcular registros relacionados");
    } finally {
      this.setState({ loadingCounts: false });
    }
  };

  handleConfirm = async () => {
    const { op, onDeleteSuccess } = this.props;
    const { confirmationText, password } = this.state;

    if (confirmationText !== op) {
      message.error("El número de Orden de Producción no coincide");
      return;
    }

    if (password !== "pcpedit246.") {
      message.error("Contraseña administrativa incorrecta");
      return;
    }

    this.setState({ isDeleting: true });

    try {
      const batchSteps = [];
      const collections = ["comercial", "ing", "ddp", "telas", "corte", "costura", "acabados", "almacen"];

      for (const coll of collections) {
        const snap = await firebase.firestore().collection(coll).where("op", "==", op).get();
        snap.forEach((doc) => {
          batchSteps.push(firebase.firestore().collection(coll).doc(doc.id).delete());
        });
      }

      await Promise.all(batchSteps);

      notification.success({
        message: "Eliminación Completada",
        description: `La Orden de Producción ${op}, su registro comercial y todos sus procesos han sido eliminados.`,
      });

      onDeleteSuccess();
    } catch (error) {
      console.error("Error during deletion:", error);
      notification.error({
        message: "Error de Eliminación",
        description: "Hubo un problema al intentar eliminar los registros.",
      });
    } finally {
      this.setState({ isDeleting: false });
    }
  };

  render() {
    const { visible, onCancel, op } = this.props;
    const { counts, loadingCounts, isDeleting, confirmationText, password } = this.state;

    const isNameCorrect = confirmationText === op;
    const isPasswordCorrect = password === "pcpedit246.";

    const summaryData = [
      { label: "Registros en DDP", value: counts.ddp, icon: "🎨" },
      { label: "Registros de Telas", value: counts.telas, icon: "🧵" },
      { label: "Registros de Corte", value: counts.corte, icon: "✂️" },
      { label: "Registros de Costura", value: counts.costura, icon: "🧥" },
      { label: "Registros de Acabados", value: counts.acabados, icon: "✨" },
      { label: "Registros de Almacén", value: counts.almacen, icon: "🏭" },
    ];

    return (
      <Modal
        title={
          <div style={{ 
            display: "flex", 
            alignItems: "center", 
            gap: "8px", 
            backgroundColor: "#ff4d4f", 
            color: "white", 
            margin: "-16px -24px", 
            padding: "16px 24px",
            borderRadius: "4px 4px 0 0" 
          }}>
            <Icon type="delete" style={{ color: "white", fontSize: "20px" }} />
            <span style={{ fontSize: "18px", fontWeight: "bold", lineHeight: "20px" }}>Eliminar Orden de Producción</span>
          </div>
        }
        visible={visible}
        onCancel={onCancel}
        footer={[
          <Button key="cancel" onClick={onCancel} disabled={isDeleting}>
            Cancelar
          </Button>,
          <Button
            key="delete"
            type="danger"
            loading={isDeleting}
            onClick={this.handleConfirm}
            disabled={loadingCounts || !isNameCorrect || !isPasswordCorrect}
            style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}
          >
            {!isDeleting && <Icon type="delete" style={{ marginRight: 8 }} />}
            <span>Eliminar</span>
          </Button>,
        ]}
        width={480}
        centered
      >
        <div style={{ padding: "10px 0" }}>
          <p>
            Eliminarás la Orden de Producción: <strong style={{ fontWeight: "bold" }}>{op}</strong>
          </p>
          <p style={{ color: "rgba(0, 0, 0, 0.45)", fontSize: "14px", marginTop: 10 }}>
            Se eliminarán permanentemente los registros asociados en los siguientes procesos:
          </p>
          <div style={{ marginTop: 10 }}>
            <Spin spinning={loadingCounts}>
              <List
                size="small"
                dataSource={summaryData}
                renderItem={(item) => (
                  <List.Item style={{ padding: "4px 0", display: "flex", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ marginRight: 8, fontSize: "16px" }}>{item.icon}</span>
                      <span>{item.label}</span>
                    </div>
                    <span style={{ fontWeight: "bold" }}>{item.value}</span>
                  </List.Item>
                )}
              />
            </Spin>
          </div>

          <Divider style={{ margin: "20px 0" }} />

          <div style={{ background: "#fff2f0", padding: "12px", borderRadius: "8px", border: "1px solid #ffccc7", marginBottom: 20, display: "flex", alignItems: "center" }}>
            <Icon type="warning" style={{ color: "#ff4d4f", marginRight: 8, fontSize: "16px" }} />
            <span style={{ color: "#ff4d4f", fontWeight: "bold" }}>
              Atención: Esta acción eliminará la OP de Ingeniería y todos sus subprocesos.
            </span>
          </div>

          <div style={{ marginBottom: 15 }}>
            <span style={{ fontWeight: "bold", display: "block", marginBottom: 8 }}>
              1. Escriba el número de la OP <code style={{ backgroundColor: "#f5f5f5", padding: "2px 4px", borderRadius: "4px" }}>{op}</code>:
            </span>
            <Input
              placeholder={`Escriba "${op}"`}
              value={confirmationText}
              onChange={(e) => this.setState({ confirmationText: e.target.value })}
              disabled={isDeleting || loadingCounts}
            />
          </div>

          <div style={{ marginBottom: 10, opacity: isNameCorrect ? 1 : 0.5, transition: "opacity 0.3s" }}>
            <span style={{ fontWeight: "bold", display: "block", marginBottom: 8 }}>
              2. Ingrese la contraseña administrativa:
            </span>
            <Input.Password
              placeholder="Contraseña"
              value={password}
              onChange={(e) => this.setState({ password: e.target.value })}
              disabled={isDeleting || loadingCounts || !isNameCorrect}
              prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
            />
          </div>
        </div>
      </Modal>
    );
  }
}

export default EngineeringDeletionModal;
